import { PipaBalanceProps } from './types';
import { StyledPipaBalance } from './style';
import { formattingNumber } from 'utils';

const PipaBalance = ({ balance, balanceQuantityFormat }: PipaBalanceProps) => {
  return (
    <StyledPipaBalance>
      <div className="img-container">
        <img
          className="img-container--balance"
          alt="balance"
          src={balance.image}
        />
      </div>
      <span>
        {balanceQuantityFormat
          ? formattingNumber({
              number: balance.amount,
              config: balanceQuantityFormat,
              multiplier: 100,
            })
          : balance.amount}
      </span>
    </StyledPipaBalance>
  );
};

export default PipaBalance;
